module.exports = __webpack_public_path__ + "img/康复用品.d993730d.png";